module.exports = __webpack_public_path__ + "img/approveByCPL.1f3fb89f.svg";